import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VContainer,{staticClass:"not-found"},[_c('h1',[_vm._v("Nicht gefunden")]),_c('p',[_vm._v(" Der genutzte Link ist leider nicht mehr gültig. ")]),_c('a-trigger-primary-process-button',{attrs:{"to":{ name: 'root' },"is-exact":""}},[_vm._v(" Zur Anmeldung ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }